import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { deLocale } from 'ngx-bootstrap/locale';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { environment } from 'src/environments/environment.prod';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardService } from './auth-guard.service';
import { AuthInterceptor } from './auth-interceptor';
import { ConfigService } from './config.service';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { SharedModule } from './shared/shared.module';
import { reducer } from './state/app.state';
import { UiModule } from './ui/ui.module';

registerLocaleData(localeDe, 'de');
defineLocale('de', deLocale);

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot(reducer),
    StoreModule.forFeature('app', reducer),
    ToastModule,
    PopoverModule.forRoot(),
    AccordionModule.forRoot(),
    TooltipModule.forRoot(),
    CollapseModule.forRoot(),
    EffectsModule.forRoot([]),
    // EffectsModule.forFeature([SettingsEffects]),,
    ModalModule.forRoot(),
    UiModule,
    AppRoutingModule,
    SharedModule,
    StoreDevtoolsModule.instrument({ name: 'BTV CMS Frontend', maxAge: 25, logOnly: environment.develop }),
    BsDatepickerModule.forRoot(),
    FontAwesomeModule,
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: LOCALE_ID, useValue: 'de' },
  {
    provide: APP_INITIALIZER,
    useFactory: loadConfigurations,
    deps: [ConfigService],
    multi: true
  },
    MessageService, AuthGuardService],
  bootstrap: [AppComponent],
  // entryComponents: [ModalModule]
})
export class AppModule { }

export function loadConfigurations(configService: ConfigService): () => {} {
  return () => configService.getConf();
}
